/**
 * String constants for EDMS Document Type Fields page.
 */

export const PAGE = {
  title: 'Document Type Fields',
  description:
    'Manage Document Type Fields used in the document management system. Use the filters below to refine the list.',
};

export const ACTIONS = {
  create: 'Create Document Type Field',
  edit: 'Update Document Type Field',
  delete: 'Delete Document Type Field',
  cancel: 'Cancel',
};

export const SEARCH = {
  placeholder: 'Search document type fields…',
  inputId: 'document-type-field-search',
};

export const ACTIVE_FILTER = {
  selectId: 'document-type-field-active',
};

export const MESSAGES = {
  createSuccess: 'Document Type Field created successfully.',
  createError: 'Unable to create Document Type Field. Please try again.',
  updateSuccess: 'Document Type Field updated successfully.',
  updateError: 'Unable to update Document Type Field. Please try again.',
  updateMissingId: 'Unable to update Document Type Field: missing Document Type Field identifier.',
  deleteSuccess: 'Document Type Field deleted successfully.',
  deleteError: 'Unable to delete Document Type Field. Please try again.',
};

export const CONFIRM = {
  updateTitle: 'Update Document Type Field?',
  updateMessage: 'Apply the pending changes?',
  deleteTitle: 'Delete Document Type Field?',
  deleteMessage: (name) =>
    `This will remove "${name || 'this Document Type Field'}" and any linked records. This action cannot be undone.`,
};

export const SUCCESS_DIALOG = {
  successTitle: 'Success',
  errorTitle: 'Action required',
};

/** Data type options for document type field (backend expects string). */
export const DATA_TYPE_OPTIONS = [
  { value: 'string', label: 'String' },
  { value: 'number', label: 'Number' },
  { value: 'boolean', label: 'Boolean' },
  { value: 'date', label: 'Date' },
  { value: 'datetime', label: 'Date & Time' },
  { value: 'text', label: 'Text' },
];
